'use client';

import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import { MAX_SUPERSTAR_SEARCH_TEXT_LENGTH } from '@wwe-portal/web/utils/constants/superstar';
import { useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

export type RosterSearchFilterKey =
  | 'playStyle'
  | 'era'
  | 'class'
  | 'searchText'
  | 'searchTarget'
  | 'owned';

export const useSearchFilter = () => {
  const searchParams = useSearchParams();
  const playStyle = searchParams.get('playStyle');
  const era = searchParams.get('era');
  const classValue = searchParams.get('class');
  const originSearchText = searchParams.get('searchText') ?? '';
  const searchText = originSearchText
    .trim()
    .slice(0, MAX_SUPERSTAR_SEARCH_TEXT_LENGTH);
  const searchTarget = searchParams.get('searchTarget');
  const ownedString = searchParams.get('owned');
  const isAuthenticated = useIsAuthenticated();
  const owned = Boolean(ownedString) && isAuthenticated;

  const enabled =
    Boolean(playStyle) ||
    Boolean(era) ||
    Boolean(classValue) ||
    searchText.length > 1;

  return {
    playStyle,
    era,
    classValue,
    searchText,
    searchTarget,
    owned,
    enabled,
  };
};

export const useChangeSearchFilter = () => {
  const changeSearchFilter = useCallback(
    (nextParams: Partial<Record<RosterSearchFilterKey, string | null>>) => {
      const nextSearchParams = new URLSearchParams(location.search);
      Object.entries(nextParams).forEach(([key, value]) => {
        if (value) {
          nextSearchParams.set(key, value);
        } else {
          nextSearchParams.delete(key);
        }
      });
      const currentPath = window.location.pathname;
      history.replaceState(
        null,
        '',
        `${currentPath}?${nextSearchParams.toString()}`
      );
    },
    []
  );

  return {
    changeSearchFilter,
  };
};
